export default __webpack_public_path__ + "static/media/quiz.700c7702.svg";